import Loadable from '../../components/loadable';

const TemplatesList = Loadable({
  loader: () => import('react/pages/templates/templates_list'),
  type: 'block',
});

angular.module('gym').value('TemplatesList', TemplatesList);
